export const IMAGE_URL_BASE = 'http://dev.agenda.jumpittlabs.cl/api/images?path=';
export const LOCK_STATUS_ACTIVE = 1;
export const LOCK_STATUS_INACTIVE = 0;

